// extracted by mini-css-extract-plugin
export default {"root":"page_layout_root__k68Ap"};